<div class="content-wrapper d-flex align-items-center auth px-0">
    <div class="row w-100 mx-0">
      <div class="col-lg-4 mx-auto">
        <div class="auth-form-light text-left py-5 px-4 px-sm-5">
          <div class="brand-logo">
            <img src="assets/brand/footer-logo.png" alt="logo">
          </div>
          <h4>Welcome! let's get started</h4>
          <h6 class="fw-light">Sign in to continue.</h6>
          <form class="pt-3" [formGroup]="loginForm" (ngSubmit)="onSubmit($event,loginForm)">
            <div class="form-group">
              <input type="text" class="form-control form-control-lg" formControlName="username" id="exampleInputEmail1" placeholder="Username">
              <div class="invalid-feedback d-block"
                  *ngIf="f['username'].errors?.['required'] && (f['username'].dirty || f['username'].touched)">
                  Please fill valid username.
              </div>
            </div>
            <div class="form-group">
              <input type="password" class="form-control form-control-lg" formControlName="password" id="exampleInputPassword1" placeholder="Password">
              <div class="invalid-feedback d-block"
                  *ngIf="f['password'].errors?.['required'] && (f['password'].dirty || f['password'].touched)">
                  Please fill password.
              </div>
              <div class="invalid-feedback d-block"
                  *ngIf="f['password'].errors?.['minlength'] && (f['password'].dirty || f['password'].touched)">
                  Your password must have minimum 8 characters.
              </div>
            </div>
            <div class="mt-3">
              <a class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" (click)="onSubmit($event,loginForm)">SIGN IN <i *ngIf="formSubmitting" class="fa fa-spinner fa-spin"></i></a>
            </div>
            <div class="my-2 d-flex justify-content-between align-items-center">
              <a routerLink="/admin/forgot-password" class="auth-link text-black ms-auto">Forgot password?</a>
            </div>
            <!-- <div class="text-center mt-4 fw-light">
              Don't have an account? <a routerLink="/admin/signup" class="text-primary">Create</a>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>